
import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

interface CardFormActionsProps {
  isVerifying: boolean;
  isPolicyVerifying: boolean;
  isVerified: boolean;
  isPolicyVerified: boolean;
  verificationError?: string;
  onBack: () => void;
  onRetry?: () => void;
}

const CardFormActions: React.FC<CardFormActionsProps> = ({
  isVerifying,
  isPolicyVerifying,
  isVerified,
  isPolicyVerified,
  verificationError,
  onBack,
  onRetry
}) => {
  return (
    <div className="space-y-4">
      {verificationError && (
        <div className="flex items-center gap-2 p-3 text-sm text-red-600 bg-red-50 rounded-md">
          <AlertCircle className="h-4 w-4" />
          <p>{verificationError}</p>
        </div>
      )}

      <div>
        <Button 
          type="submit" 
          className="w-full" 
          disabled={isVerifying || isPolicyVerifying}
        >
          {isVerifying || isPolicyVerifying ? 'AI verification in progress...' : 
           isVerified && isPolicyVerified ? 'Create account with verified card' : 
           !isPolicyVerified ? 'Verify policy understanding with AI' : 
           verificationError ? 'Try again with new card' : 'Verify card with Stripe AI'}
        </Button>
      </div>

      {verificationError && onRetry && (
        <div>
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={onRetry}
          >
            Enter new card details
          </Button>
        </div>
      )}

      <div>
        <Button 
          type="button" 
          variant="outline" 
          className="w-full" 
          onClick={onBack}
        >
          Back
        </Button>
      </div>
    </div>
  );
};

export default CardFormActions;
